import React, { useState, useEffect } from "react";

import { config } from "../../config";
import { handleResponse } from "../../helpers/response";
import i18n from "i18next";
import loader from "../../images/loader.svg";

const MiddleMenu = () => {
  const [middleMenu, setMiddleMenu] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    const menutype = "middle_menu_export_" + i18n.language;
    const link =
      config.apiUrl +
      "api/import/joomla/topmenu/" +
      i18n.language +
      "?menutype=" +
      menutype;
    fetch(link, { method: "GET" })
      .then(handleResponse)
      .then((json) => {
        setMiddleMenu(json);
        setShowLoader(false);
      })
      .catch((error) => {
        alert("error");
      });
    
  }, []);
  return (
    <>
      <li
        className={
          showLoader ? "menu-loader uk-position-relative " : "uk-hidden"
        }
      >
        <div className="loader-overlay  uk-position-z-index">
          <div className="uk-position-center">
            <img
              className="loader-img"
              src={loader}
              uk-svg={""}
              alt={"loading..."}
            />
          </div>
        </div>
      </li>
      {showLoader === false && (
        Object.keys(middleMenu.joomla).map((id, inx) => {
          const parentId = middleMenu.joomla[inx].id;
        return (
            middleMenu.joomla[inx]!== undefined && middleMenu.joomla[inx].parentId === 1 && (
            <li key={id}>
              <a
                className="header-nav__link"
                href={middleMenu.joomla[inx].type != 'url' ?config.siteUrl + middleMenu.joomla[inx].path:'#'}
              >
                {middleMenu.joomla[inx].title}
     
              </a>
              <div className="uk-navbar-dropdown menu-dropdown uk-box-shadow-large uk-dropdown" uk-dropdown="pos: bottom-left">
                <ul className="uk-nav uk-navbar-dropdown-nav">
                  {
                    Object.keys(middleMenu.joomla).map((id, inx) => {
                     
                        return(
                        middleMenu.joomla[inx]!== undefined && middleMenu.joomla[inx].parentId == parentId && (
                          
                          <li key={inx+1}>
                        
                            <a
                              className="header-nav__link"
                              href={config.siteUrl + middleMenu.joomla[inx].path}
                            >
                             
                              {middleMenu.joomla[inx].title}
                            
                            </a>
                          </li>
                      )
                    
                      )           
                    })
                  }
                </ul>
              </div>
            </li>
          )
        );
      }))
    }
      
    </>
  );
};
export default MiddleMenu;
